import React from 'react';
import { useTranslation } from 'react-i18next';
import { typeFilterButtons } from 'types/content';
import FilterButtons from 'components/FilterButtons';
import { jsx as _jsx } from "react/jsx-runtime";
function ContentTypeFilter() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(FilterButtons, {
    label: t('property_type_colon'),
    queryParam: "type",
    options: typeFilterButtons,
    defaultOption: "all"
  });
}
export default ContentTypeFilter;